/* eslint-disable no-unused-expressions */
/******************************************************************************
 * PinchZoomControl Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/



//============================================================================= PinchZoomControl Class
export default class PinchZoomControl {
	enabled = true

	pos = {x:0, y:0}
	last = {x:0, y:0}
	touchPoints = []
	onZoom = null
	onMove = null
	onUpdate = null

	stageScale = 1
	scaleFactor = 1
	scale = 1
	initScale = 1
	minScale = 0.8
	maxScale = 4
	scaleStep = 0.1			//step per wheel

	useLimits = false
	limitOffset = 0

	size = {w:0, h:0}


	constructor(props){
		this.onZoom = props?.onZoom
		this.onMove = props?.onMove
		this.onUpdate = props?.onUpdate
		this.useLimits = props?.useLimits || false

		this.onWheelBind = this.onWheel.bind(this)
		this.onDownBind = this.onDown.bind(this)
		this.onUpBind = this.onUp.bind(this)
		this.onMoveBind = this.onMouseMove.bind(this)
		this.onTouchStartBind = this.onTouchStart.bind(this)
		this.onTouchMoveBind = this.onTouchMove.bind(this)
		this.onTouchEndBind = this.onTouchEnd.bind(this)
	}


	// ------------------------------------------------------------------------ autoScale
	// auto center and set scaling values
	autoScale(scaleFactor=5){
		let parent = this.target.parentNode
		let p0 = parent.clientWidth / parent.clientHeight
		let t0 = this.target.clientWidth / this.target.clientHeight
		
		let sc, x0, y0
		if (p0 > t0){
			sc = parent.clientWidth / this.target.clientWidth
			x0 = 0
			y0 = (parent.clientHeight - this.target.clientHeight * sc) / 2
		}else{
			sc = parent.clientHeight / this.target.clientHeight
			x0 = (parent.clientWidth - this.target.clientWidth * sc) / 2
			y0 = 0
		}

		this.initScale = sc
		this.minScale = sc
		this.maxScale = sc * scaleFactor

		this.updateTarget(this.initScale, x0, y0)
	}


	updateTarget(scale, x, y){
		if (scale === this.scale && x === this.pos.x && y === this.pos.y) return	//no change

		if (scale !== undefined) this.scale = scale
		if (x !== undefined) this.pos.x = x
		if (y !== undefined) this.pos.y = y

		this.scaleFactor = this.scale / this.initScale

		// --- with scaling
		// this.target.style.transform = 'scale(' + this.scale + ')'
		this.target.style.transform = 'scale(' + this.scale + ')'

		//--- without scaling. update width and height only
		// this.target.style.width = (this.size.w * this.scale) + 'px'
		// this.target.style.height = (this.size.h * this.scale) + 'px'

		if (this.useLimits){
			let xo = this.target.parentNode.clientWidth - this.limitOffset - this.target.clientWidth * this.scale
			if (this.pos.x < xo) this.pos.x = xo
			let yo = this.target.parentNode.clientHeight - this.limitOffset - this.target.clientHeight * this.scale
			if (this.pos.y < yo) this.pos.y = yo

			if (this.pos.x > this.limitOffset) this.pos.x = this.limitOffset
			if (this.pos.y > this.limitOffset) this.pos.y = this.limitOffset
		}

		this.target.style.left = this.pos.x + 'px'
		this.target.style.top = this.pos.y + 'px'

		this.onUpdate?.(this.scale, this.pos)
	}


	resetTarget(){
		this.target.removeEventListener('mousewheel', this.onWheelBind)
		this.target.removeEventListener('mousedown', this.onDownBind)
		document.removeEventListener('mouseup', this.onUpBind)

		this.target.removeEventListener('touchstart', this.onTouchStartBind);
		// document.removeEventListener('touchmove', this.onTouchMoveBind)
		this.target.removeEventListener('touchmove', this.onTouchMoveBind)
		this.target.removeEventListener('touchend', this.onTouchEndBind)

		// this.scale = this.initScale
		// this.pos.x = this.last.x
		// this.pos.y = this.last.y
		this.updateTarget(1, 0, 0)
	}


	setTarget(target){
		// console.log('---set pinchZoomTarget:', target)

		if (this.target) this.resetTarget()
		if (!target) return

		this.target = target
		this.target.style.position = 'absolute'
		this.target.style.zIndex = 1
		this.target.style.transformOrigin = '0 0'

		// this.scale = this.initScale
		// this.last.x = this.pos.x = Number(this.target.style.left.split('px')[0])
		// this.last.y = this.pos.y = Number(this.target.style.top.split('px')[0])

		this.size.w = this.target.clientWidth
		this.size.h = this.target.clientHeight
		// console.log('   size:', this.size)

		target.addEventListener('mousewheel', this.onWheelBind)
		target.addEventListener('mousedown', this.onDownBind)
		document.addEventListener('mouseup', this.onUpBind)

		target.addEventListener('touchstart', this.onTouchStartBind)
		// document.addEventListener('touchmove', this.onTouchMoveBind)
		target.addEventListener('touchmove', this.onTouchMoveBind)
		target.addEventListener('touchend', this.onTouchEndBind)

		let x0 = Number(this.target.style.left.split('px')[0])
		let y0 = Number(this.target.style.top.split('px')[0])

		this.updateTarget(this.initScale, x0, y0)

		this.last.x = this.pos.x
		this.last.y = this.pos.y
	}


	onTouchStart(e){
		if (!this.enabled) return

		e.preventDefault()
		console.log('touch-start', e.touches.length)
		console.log(e.touches[0].clientX, e.touches[0].clientY, e.touches[0].pageX, e.touches[0].pageY)
		this.touchPoints = e.touches

		let parent = this.target.parentNode
		if (parent) this.stageScale = parent.getBoundingClientRect().width / parent.clientWidth
	}


	onTouchMove(e){
		e.preventDefault()

		if (!this.enabled) return

		let t = e.touches
		let p = this.touchPoints	//last points

		// console.log(e.touches[0].clientX)

		if (t.length === 1){		//single touch
			this.pos.x += (t[0].clientX - p[0].clientX) / this.stageScale
			this.pos.y += (t[0].clientY - p[0].clientY) / this.stageScale
	
		}else if (t.length >= 2){	//multi touch
			let tx = (t[0].clientX + t[1].clientX) / 2
			let ty = (t[0].clientY + t[1].clientY) / 2
			let px = (p[0].clientX + p[1].clientX) / 2
			let py = (p[0].clientY + p[1].clientY) / 2

			//---move only
			this.pos.x += (tx - px) / this.stageScale
			this.pos.y += (ty - py) / this.stageScale

			//---check zooming
			let s0 = distance(t) / distance(p)

			if ((s0 > 1 && this.scale < this.maxScale) || (s0 < 1 && this.scale > this.minScale)){
				if (s0 > 1 && s0 * this.scale > this.maxScale) s0 = this.maxScale / this.scale
				else if (s0 < 1 && s0 * this.scale < this.minScale) s0 = this.minScale / this.scale
				this.scale *= s0

				let rect = this.target.getBoundingClientRect();
				this.pos.x += (tx - rect.x) * (1 - s0) / this.stageScale
				this.pos.y += (ty - rect.y) * (1 - s0) / this.stageScale
			}
		}

		this.touchPoints = t

		this.updateTarget()

		this.onZoom?.(this.scale)
		this.onMove?.(this.pos)
	}

	onTouchEnd(e){
		e.preventDefault()
		console.log('touch-end', e.touches.length)
		this.touchPoints = e.touches
	}


	onDown(e){
		if (!this.enabled) return

		e.preventDefault()
		document.addEventListener('mousemove', this.onMoveBind)

		let parent = this.target.parentNode
		if (parent) this.stageScale = parent.getBoundingClientRect().width / parent.clientWidth
	}


	onMouseMove(e){
		if (!this.enabled) return

		e.preventDefault()
		this.pos.x += e.movementX / this.stageScale
		this.pos.y += e.movementY / this.stageScale

		this.updateTarget()

		this.onMove?.(this.pos)
	}

	onUp(e){
		e.preventDefault()
		document.removeEventListener('mousemove', this.onMoveBind)
	}


	onWheel(e){
		if (!this.enabled) return

		e.preventDefault()
		let s0
		if (e.deltaY < 0){	//zoom in
			if (this.scale === this.maxScale) return
			s0 = Math.min(this.scale * (1 + this.scaleStep), this.maxScale)

		}else{		//zoom out
			if (this.scale === this.minScale) return
			s0 = Math.max(this.scale / (1 + this.scaleStep), this.minScale)
		}

		this.pos.x += e.offsetX * (this.scale - s0)
		this.pos.y += e.offsetY * (this.scale - s0)

		this.updateTarget(s0)

		this.onZoom?.(this.scale)
	}
}


const distance = (e) => {
	return Math.hypot(e[0].pageX - e[1].pageX, e[0].pageY - e[1].pageY);
};


const info = (e, a) => {
	let str = ''
	for (let i in e){
		str += i + ' ' + e[i] + '\n'
	}
	console.log(str)
	if (a) alert(str)
}